import { DateTime } from 'luxon';
import { FC } from 'react';

export const FormatTimezone: FC<{ format?: string; zone?: string }> = ({ format = "'(UTC 'ZZ') 'z", zone }) => {
  if (zone) return <>{DateTime.fromObject({}, { zone }).setLocale(navigator.language).toFormat(format)}</>;
  return <>{DateTime.now().setLocale(navigator.language).toFormat(format)}</>;
};

export default FormatTimezone;
